import React from 'react'
import Contact from '../component/Contact'

function ContactUs() {
  return (
    <div>
      <Contact />
    </div>
  )
}

export default ContactUs